import Response from '../base/Response';
import ServiceBehaviour from "../base/ServiceBehaviour";
import Modal from './PixelPayModal';
import Loading from './PixelPayLoading';

export default class PayloadManager extends ServiceBehaviour {
	/**
	 * Create a new IFRAME DOM element
	 *
	 * @param {*} onerror
	 */
	private createIFrameElement(onerror: any): HTMLIFrameElement {
		const iframe = document.createElement('iframe');

		iframe.setAttribute('frameborder', '0');
		iframe.setAttribute('frameborder', '0');
		iframe.setAttribute('scrolling', 'auto');
		iframe.setAttribute('allowtransparency', 'true');

		iframe.classList.add('pixelpay-modal-iframe');
		iframe.classList.add('pixelpay-modal-loading');

		iframe.onload = () => {
			iframe.classList.remove('pixelpay-modal-loading');
		}

		iframe.onerror = onerror;

		return iframe;
	}

	/**
	 * Evalua las respuestas enviadas por @method postMessage()
	 * desde el servidor de la URL agregada al iFrame
	 *
	 * @param {object} ev
	 * @param {*} resolve
	 * @param {*} reject
	 */
	private evaluatePostMessage(ev: any, resolve: (value: Response | PromiseLike<Response>) => void, reject: (reason?: any) => void) {
		if (!ev || !ev.data || !ev.data.hasOwnProperty('success')) {
			return;
		}

		Modal.hide();

		if (ev?.origin == this.settings.endpoint) {
			setTimeout(() => {
				Loading.hide();
				resolve(this.parseResponse(ev?.data, ev?.data?.status || (ev?.data?.success ? 200 : 400)));
			}, 300);
		} else {
			Loading.hide();
			reject(new Error(ev?.data?.message || 'Payload frame response error'))
		}
	}

	/**
	 * Método encargado de ejecutar al proceso de carga del Iframe
	 *
	 * @param {*} payload
	 * @param {*} source_url
	 * @returns
	 */
	loadPayload(payload: any, source_url?: string | null): Promise<Response> {
		return new Promise((resolve, reject) => {
			try {
				const container = document.querySelector('[without-sdk-modal]') || Modal._init().querySelector('.pixelpay-modal-container');

				if (container) {
					const iframe = this.createIFrameElement(reject);

					container.appendChild(iframe);

					if (source_url) {
						iframe.src = source_url;
						console.log('Set src url: ', source_url);
					} else {
						const iframe_document = iframe.contentWindow?.document;
						const iframe_content = atob(payload);

						iframe_document?.open();
						iframe_document?.write(iframe_content);
						iframe_document?.close();
					}

					window.onmessage = (ev: any) => {
						this.evaluatePostMessage(ev, resolve, reject);
					}
				}

				Modal.show();
			} catch (err) {
				Loading.hide();
				reject(err);
			}
		});
	}
}
